import { useEffect } from 'react';
import type { Socket } from 'socket.io-client';
import type { Ticket } from '@/entities/ticket';
import { acquireSocket, releaseSocket } from '@/shared/api';
import { useTicketsStore } from './tickets-store';

let holders = 0;
let detach: (() => void) | null = null;

function attach(): () => void {
  let cancelled = false;
  let socket: Socket | null = null;
  const onTicketUpdated = (payload: { ticket?: Partial<Ticket> & { id?: string } }) => {
    if (payload?.ticket?.id) {
      useTicketsStore.getState().applyTicketUpdate(payload.ticket as Partial<Ticket> & { id: string });
    }
  };
  void acquireSocket().then((s) => {
    if (cancelled || !s) return;
    socket = s;
    s.on('ticket_updated', onTicketUpdated);
  });
  return () => {
    cancelled = true;
    socket?.off('ticket_updated', onTicketUpdated);
    releaseSocket();
  };
}

export function useTicketsLive(): void {
  useEffect(() => {
    if (holders++ === 0) detach = attach();
    return () => {
      if (--holders === 0) {
        detach?.();
        detach = null;
      }
    };
  }, []);
}
